export const faq_program = [
  {
    title: "What support is provided to Buddha Fellows?",

    content:
      "Buddha Fellows are provided support for two years to grow their enterprise revenue as well as their social impact. We provide holistic support in the form of dedicated Anchors and Mentors, financial support for working capital needs, capacity-knowledge building-networking workshops, collaboration opportunities shared support for marketing, branding, accounting, compliance and legal aspects, and connects with government and other relevant institutions.",
  },
  {
    title:
      "What is expected from Buddha Fellows? What is my commitment for two years?",

    content:
      "Buddha Fellowship is an engaged program. We expect Buddha Fellows to fully and actively participate in the various programmatic offerings and periodic progress checks. As one Buddha Fellow said, “You will be served things – it is up to you how much value you want to draw out of it.” ",
  },
  {
    title: "Can I request the industry Mentor I want?",

    content:
      "Yes, we invite both Fellows and Mentors to give their preferences for who they want to work with. Matches are made based on this common expression of interest.",
  },
  {
    title:
      "Can I partner with other Buddha Fellows (current and past) for my enterprise?",

    content:
      "Yes, absolutely. We encourage Buddha Fellows to collaborate. The problems we are looking to solve — poverty, unemployment, climate change — are large problems that require people to work collaboratively. the Buddha Institute will be happy to facilitate these connections.",
  },
  {
    title:
      "How much monetary support is provided by the Buddha Institute? What can I use the money for in my business?",

    content:
      "The Buddha Institute provides an average monetary support of ₹10 lakhs to each Buddha Fellow. While there is flexibility in utilizing the funds, we strongly discourage using them as working capital or for loan repayment.",
  },
  {
    title:
      "Are there any circumstances under which the Fellowship can be taken back?",

    content:
      "Yes, the Fellowship can be withdrawn if the conditions outlined and agreed upon in the Memorandum of Understanding (MoU) are not fulfilled.",
  },
  {
    title:
      "What is the role of the Anchor? How is Anchor assigned? Can I pick my own Anchor?",

    content:
      "The Anchor provides consistent support and opportunities to the Buddha Fellow throughout their early entrepreneurial journey, ensuring alignment with the program’s goals. Anchors are assigned based on either geographic proximity or subject matter expertise by the Buddha Institute. ",
  },
];
